
import { defineComponent } from "vue";

function buildInitials(name: string, fallback: string): string {
  const label = String(name || "").trim() || String(fallback || "").trim();
  const parts = label.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return "?";
}

export default defineComponent({
  name: "social-account-avatar",
  props: {
    avatar: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    fallbackId: {
      type: String,
      default: ""
    },
    sizePx: {
      type: Number,
      default: 35
    }
  },
  data() {
    return {
      imageError: false
    };
  },
  computed: {
    sizeClass(): string {
      if (this.sizePx === 35) {
        return "symbol-35px";
      }
      if (this.sizePx === 45) {
        return "symbol-45px";
      }
      return "";
    },
    sizeStyle(): Record<string, string> | undefined {
      if (this.sizePx === 35 || this.sizePx === 45) {
        return undefined;
      }
      const px = `${this.sizePx}px`;
      return { width: px, height: px };
    },
    showImage(): boolean {
      return Boolean(String(this.avatar || "").trim()) && !this.imageError;
    },
    initials(): string {
      return buildInitials(this.name, this.fallbackId);
    },
    altText(): string {
      const name = String(this.name || "").trim();
      return name || "Social account";
    }
  },
  watch: {
    avatar() {
      this.imageError = false;
    }
  },
  methods: {
    onImageError() {
      this.imageError = true;
    }
  }
});
